/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

import { CIColors } from 'shared';

import checkMark from '../../../assets/images/сheck_mark.svg';

export const createCheckboxStyles = makeStyles(() => ({
  icon: {
    borderRadius: 4,
    width: 20,
    height: 20,
    backgroundColor: '#fff',
    boxShadow: 'inset 0px 0px 0px 2px #BEC2C6',
    'input:hover ~ &': {
      boxShadow: `inset 0px 0px 0px 2px `,
    },
    'input:disabled ~ &': {
      boxShadow: 'inset 0px 0px 0px 2px #CED9E0',
      background: '#e8f3fa',
    },
  },
  checkedIcon: {
    backgroundColor: CIColors.Primary,
    position: 'relative',
    boxShadow: `inset 0px 0px 0px 2px ${CIColors.Primary}`,
    '&:before': {
      display: 'block',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 11,
      height: 9,
      backgroundImage: `url('${checkMark}')`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: `${CIColors.Primary}DD`,
      boxShadow: `inset 0px 0px 0px 2px ${CIColors.Primary}10`,
    },
    'input:disabled ~ &': {
      boxShadow: `inset 0px 0px 0px 2px ${CIColors.Primary}`,
      background: CIColors.Primary,
      opacity: '.8',
    },
  },
}));
